import { FooterContent } from '../FooterContent';
import { ContentWrapper } from './ContentWrapper';

interface PageWrapperProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  showFooter?: boolean;
  contentWrapperStyle?: React.CSSProperties;
}

export const PageWrapper = ({
  style,
  showFooter = true,
  children,
  contentWrapperStyle,
}: PageWrapperProps) => {
  return (
    <div style={style}>
      <ContentWrapper style={contentWrapperStyle}>{children}</ContentWrapper>
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px 10px',
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: -100,
            left: 0,
            right: 0,
            height: 200,
            background: 'linear-gradient(#eef1f4, #fff)',
          }}
        ></div>
        {showFooter && <FooterContent />}
      </div>
    </div>
  );
};
